import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useCart } from '~/composables/useCart';
export default defineComponent({
  components: {
    AzButton: AzButton,
    AzIcon: AzIcon,
    IconBadge: function IconBadge() {
      return import('~/components/ui/IconBadge.vue');
    }
  },
  setup: function setup() {
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useCart = useCart(),
      countItemsWithoutGift = _useCart.countItemsWithoutGift;
    return {
      toggleCartSidebar: toggleCartSidebar,
      countItemsWithoutGift: countItemsWithoutGift
    };
  }
});